module.exports = __webpack_public_path__ + "assets/1-chicago-recruiting-firm.dd693b2d.png";